import { render, staticRenderFns } from "./ItemPL.vue?vue&type=template&id=919a5472"
import script from "./ItemPL.vue?vue&type=script&lang=js"
export * from "./ItemPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports